import { useUser } from "auth";
import { Button } from "melodies-source/Button";
import { Modal } from "melodies-source/Modal";
import React from "react";
import styled from "styled-components";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const ExpiredSessionModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const { clearSession } = useUser();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      withCloseIcon={false}
      withBackdropClose={false}
    >
      <Container>
        <p>
          For your security, setting up MFA requires a recent login. Log out
          and sign back in, then continue setting up your verification method.
        </p>
        <Button onClick={clearSession}>Log Out</Button>
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
